import React from 'redux';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import './StartCashout.scss';
import { UserActions } from '../../Store/Actions';
import { useGameReducer } from '../../Store';

export const StartCashout = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const gameReducer = useGameReducer();
  const [showDialog, setShowDialog] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const confirmCashout = () => {
    setShowSpinner(true);
    UserActions.closePlayer(gameReducer.userDetail.id).then(() => {
      setShowDialog(false);
      setShowSpinner(false);
      navigate('/Cashout');
    });
  };

  return (
    <>
      <div className='trial_button cashout_widget' onClick={() => setShowDialog(true)}>
        <div className='message_icon'></div>
        <div className='message_details'>
          {t('start.cashout')}
        </div>
      </div>
      { showDialog && (<div className='confirm-dialog'>
        <div className="dialog-content">
          { showSpinner && <Spinner />}
          { !showSpinner && (
            <>
              <div className="message">{t('cashout.confirmMessage')}</div>
              <div className="action confirm"><button onClick={() => confirmCashout()}>{t('cashout.confirmBtn')}</button></div>
              <div className="message">{t('cashout.cancelMessage')}</div>
              <div className="action"><button onClick={() => setShowDialog(false)}>{t('cashout.cancelBtn')}</button></div>
            </>
          )}
        </div>
      </div>)}
    </>
  );
};
